import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Music, Menu, X, LogOut } from 'lucide-react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../../shared/firebase';

export default function Navbar() {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    window.location.href = '/';
  };

  const isActive = (path) => location.pathname === path;

  const navLinkClass = (path) => 
    `transition ${isActive(path) ? 'text-white' : 'text-white/70 hover:text-white'}`;

  return (
    <nav className="border-b border-white/10 bg-black/50 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#8146FF] rounded-lg flex items-center justify-center">
              <Music size={18} className="text-white" />
            </div>
            <span className="text-xl font-bold text-white hidden sm:block">VindJouwBandLid</span>
          </Link>
          
          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            {user ? (
              <>
                <Link to="/oproep/nieuw" className={navLinkClass('/oproep/nieuw')}>
                  Nieuwe oproep
                </Link>
                <Link to="/zoeken" className={navLinkClass('/zoeken')}>
                  Zoeken
                </Link>
                <Link to="/berichten" className={navLinkClass('/berichten')}>
                  Berichten
                </Link>
                <Link 
                  to="/profiel" 
                  className="bg-[#8146FF] hover:bg-[#6a35d9] px-5 py-2 rounded-full font-medium transition text-white"
                >
                  Dashboard
                </Link>
                <button
                  onClick={handleLogout}
                  className="text-white/50 hover:text-white transition p-2"
                  title="Uitloggen"
                >
                  <LogOut size={20} />
                </button>
              </>
            ) : (
              <>
                <Link to="/zoeken" className={navLinkClass('/zoeken')}>
                  Oproepen
                </Link>
                <Link 
                  to="/inloggen" 
                  className="bg-[#8146FF] hover:bg-[#6a35d9] px-5 py-2 rounded-full font-medium transition text-white"
                >
                  Inloggen
                </Link>
              </>
            )}
          </div>

          {/* Mobile menu button */}
          <button 
            className="md:hidden text-white/70 hover:text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Nav */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10">
            <div className="flex flex-col gap-4">
              {user ? (
                <>
                  <Link 
                    to="/oproep/nieuw" 
                    className={navLinkClass('/oproep/nieuw')}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Nieuwe oproep
                  </Link>
                  <Link 
                    to="/zoeken" 
                    className={navLinkClass('/zoeken')}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Zoeken
                  </Link>
                  <Link 
                    to="/berichten" 
                    className={navLinkClass('/berichten')}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Berichten
                  </Link>
                  <Link 
                    to="/profiel" 
                    className="bg-[#8146FF] hover:bg-[#6a35d9] px-5 py-2 rounded-full font-medium transition text-center text-white"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Dashboard
                  </Link>
                  <button
                    onClick={() => { handleLogout(); setMobileMenuOpen(false); }}
                    className="text-white/50 hover:text-white transition flex items-center gap-2 justify-center"
                  >
                    <LogOut size={18} />
                    Uitloggen
                  </button>
                </>
              ) : (
                <>
                  <Link 
                    to="/zoeken" 
                    className={navLinkClass('/zoeken')}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Oproepen
                  </Link>
                  <Link 
                    to="/inloggen" 
                    className="bg-[#8146FF] hover:bg-[#6a35d9] px-5 py-2 rounded-full font-medium transition text-center text-white"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Inloggen
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
